module.exports = __webpack_public_path__ + "assets/95189a9b835cfa10b6a4aad8b5166ae4.svg";